/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Disable_Account_LabelInputs */



/**
* | output |
* | --- |
* | "Disable Account" |
*
* @param {Team_Manager_Disable_Account_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_disable_account_label = /** @type {((inputs?: Team_Manager_Disable_Account_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Disable_Account_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désactiver le compte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konto deaktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disabilita account")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отключить учетную запись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deshabilitar cuenta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("禁用帐户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アカウントを無効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाता निष्क्रिय करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desativar conta")
	return /** @type {LocalizedString} */ ("Disable Account")
});